import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { BarLoader, ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
// import Lightbox from "yet-another-react-lightbox-lite";
// import "yet-another-react-lightbox-lite/styles.css";
import { useCart } from '../hooks/add_to_cart';
import { LiaTimesSolid } from 'react-icons/lia';
import { TostMessageContext } from "../context/TostMessage";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";

export function ProductDetails({ showModal, setShowModal, showDetails }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [pageData, setPageData] = useState({images: []});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [selected, setSelected] = useState({});
    const {convertAmount, addToCart,checkItemInCart, removeItem} = useCart();
    const [qty, setQty] = useState(checkItemInCart(showDetails?.product_id) || 1);
    const [cookies, ] = useCookies();
    const navigate = useNavigate();
    const { setTostMessage } = useContext(TostMessageContext);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    // const [open, setOpen] = React.useState(false);

    useEffect(() => {
        getData();
    }, [])

    const openViewer = (index) => {
        setCurrentIndex(index);
        setIsViewerOpen(true);
    };

    const closeViewer = () => {
        setCurrentIndex(0);
        setIsViewerOpen(false);
    };

    useEffect(() => {
        console.log(currentIndex, 'changed')
    }, [currentIndex])

    const sideImages = pageData?.images?.slice(1, 3);

    // Extra images count
    const extraCount = pageData?.images?.length - 3;

    const handleSelect = (group, option) => {
        if (selected[group]?.option === option.option) return;
        setPageData((prev) => {
            const prevOption = selected[group];
            const prevAmount = prevOption ? Number(prevOption.amount_plus) : 0;
            const newAmount = Number(option.amount_plus);

            const newStartPrice = newAmount;

            return {
            ...prev,
            start_price: newStartPrice,
            total_price: newStartPrice * qty
            };
        });

        setSelected((prev) => ({
        ...prev,
        [group]: option
        }));
    };

    const increaseQty = () => {
        setQty((prev) => {
            const newQty = prev + 1;

            setPageData((data) => ({
            ...data,
            total_price: data.start_price * newQty
            }));

            return newQty;
        });
    };

    const decreaseQty = () => {
        setQty((prev) => {
            if (prev === 1) return 1;

            const newQty = prev - 1;

            setPageData((data) => ({
            ...data,
            total_price: data.start_price * newQty
            }));

            return newQty;
        });
    };

    async function getData() {
        const formData = new FormData();
        formData.append('product_id', showDetails?.product_id);

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_product_details.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                setPageData({images: response.data.images, desc: response.data.desc, start_price: pageData?.start_price ?? response.data.start_price, base_price: response.data.start_price, total_price: pageData?.total_price ?? response.data.start_price, extras: response.data.extras })
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    const hydrateFromCart = ({
        product_id,
        cookies,
        setSelected,
        setQty,
        setPageData
    }) => {
        const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];

        const item = cart.find(
            (cartItem) => cartItem.product_id === product_id
        );

        if (!item) return;

        // Restore selected options
        setSelected(item.selected || {});

        // Restore quantity
        setQty(item.quantity || 1);

        // Recalculate price
        setPageData((prev) => {
            const variantsTotal = Object.values(item.selected || {}).reduce(
            (sum, opt) => sum + Number(opt.amount_plus),
            0
            );

            const singlePrice = prev.base_price + variantsTotal;

            return {
            ...prev,
            start_price: singlePrice,
            total_price: singlePrice * (item.quantity || 1)
            };
        });
    };

    useEffect(() => {
        if (pageLoading) return;

        var product_id = showDetails?.product_id
        hydrateFromCart({
            product_id,
            cookies,
            setSelected,
            setQty,
            setPageData
        });
    }, [pageLoading]);

    const isVideoUrl = async (url) => {
        try {
            const res = await fetch(url, { method: "HEAD" });
            const contentType = res.headers.get("content-type");

            return contentType?.startsWith("video/");
        } catch (err) {
            return false;
        }
    };

    // const slides = pageData?.images.map((item) => {
    //     if (item.type === "video") {
    //         return {
    //         type: "video",
    //         width: 1280,
    //         height: 720,
    //         poster: item.poster, // optional
    //         sources: [
    //             {
    //             src: item.url,
    //             type: item.mime || "video/mp4",
    //             },
    //         ],
    //         onPlay: () => setIsVideoPlaying(true),
    //         onPause: () => setIsVideoPlaying(false),
    //         onEnded: () => setIsVideoPlaying(false),
    //         };
    //     }

    //     // image fallback
    //     return {
    //         src: item.url,
    //     };
    // });

    const slides = useMemo(
        () =>
            pageData?.images.map((img) =>
            img.type === "video"
                ? { type: "video", sources: [{ src: img.url, type: "video/mp4" }] }
                : { src: img.url }
            ),
        [pageData]
    );

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setTostMessage({
                messageType: 'success',
                message: 'Link copied to clipboard, proceed to share'
            })
        } catch (err) {
            setTostMessage({
                messageType: 'success',
                message: 'Unable to copy link, try again'
            })
        }
    };


  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 px-5 h-full overflow-y-auto w-[100%] lg:w-[50%] fixed right-0 bg-white animate-scaleIn'>
                <div onClick={() => setShowModal(false)} className='w-auto self-end flex justify-end text-underline text-[#ff0000] cursor-pointer'>Close</div>
                <a className='text-dark text-[20px] font-bold'>{showDetails?.name}</a>
                {pageLoading &&
                    <div className="h-full w-full bg-white flex items-center justify-center">
                        <BarLoader 
                            color={'#7d5af6'}
                            loading={true}
                            size={10}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                }
                {!pageLoading &&
                <>
                <div className="max-h-[300px] md:max-h-[500px] md:px-3 md:w-[100%] grid grid-cols-3 md:grid-cols-3 my-3 md:my-5">
                    {/* Large main image */}
                    <div 
                    className="max-h-[300px] md:max-h-[500px] col-span-2 overflow-hidden cursor-pointer "
                    onClick={() => openViewer(0)}
                    >
                        {
                        pageData?.images[0]?.type == "video" ?
                        <video
                            src={pageData?.images[0]?.url}
                            className="w-full h-auto object-cover"
                            controls
                            autoPlay={false}
                        />
                        : 
                        <img 
                            src={pageData?.images[0]?.url} 
                            className="w-full h-auto md:h-full sm:h-full object-cover" 
                            alt="Main"
                        />
                        }
                    </div>

                    {/* Right side 4 images */}
                    <div className="max-h-[300px] md:max-h-[500px] grid grid-cols-1 ">
                    {sideImages.map((img, index) => {
                        const globalIndex = index + 1;
                        // const url = URL.createObjectURL(img);
                        const isVideo = img.type == "video" ? true : false;
                        return (
                        <div
                            key={index}
                            className="relative overflow-hidden cursor-pointer"
                            onClick={() => openViewer(globalIndex)}
                        >
                            {isVideo ? 
                            <video
                                src={img.url}
                                className="w-full h-full object-cover"
                                muted
                                controls
                                autoPlay={false}
                            />
                            : 
                            <img 
                                src={img.url} 
                                className="w-full h-full object-cover" 
                                alt=""
                            />
                            }
                            {/* +X overlay on the last image */}
                            {index === 1 && extraCount > 0 && (
                            <div className="absolute h-full inset-0 bg-black/60 flex items-center justify-center text-white text-3xl font-semibold">
                                +{extraCount}
                            </div>
                            )}
                        </div>
                        );
                    })} 
                    </div>
                </div>
                <div className="px-5 flex w-full flex-start">
                    <button onClick={() => copyToClipboard(`https://intimatesbyitee.com/shop-now/${showDetails?.product_id}/${showDetails?.name}`)} className="py-2 px-5 border rounded-sm my-2 text-[#853bf5] border-[#853bf5]">Share product link</button>
                </div>
                {/* IMAGE VIEWER POPUP */}
                {isViewerOpen && (
                    // <Lightbox
                    //     // open={isViewerOpen}
                    //     // close={() => setIsViewerOpen(false)}
                    //     slides={pageData?.images.map(img => ({ src: img }))}
                    //     index={currentIndex}
                    //     setIndex={setCurrentIndex}
                    // />
                    <Lightbox
                        open={isViewerOpen}
                        close={() => setIsViewerOpen(false)}
                        slides={slides}
                        index={currentIndex}
                        setIndex={setCurrentIndex}
                        plugins={[Video]}
                    />
                )}
                <div className='mt-5 px-5 self-start flex flex-start'>
                    <strong className='text-2xl md:text-3xl font-bold'>{convertAmount(pageData?.total_price)}</strong>
                </div>
                <div 
                    className='self-start prose mt-5 px-3 md:px-5'
                    dangerouslySetInnerHTML={{ __html: pageData?.desc }}
                />
                <div className="w-full my-5 px-3 md:px-5 space-y-4">
                    {pageData?.extras?.map((groupObj, index) => {
                        const groupName = Object.keys(groupObj)[0];
                        const options = groupObj[groupName];

                        return (
                        <div key={index}>
                            <h3 className="font-semibold text-lg mb-4">{groupName}</h3>

                            <div className="grid grid-cols-2 gap-4">
                            {options.map((item, i) => {
                                const isActive =
                                selected[groupName]?.option === item.option;

                                return (
                                <button
                                    key={i}
                                    onClick={() => handleSelect(groupName, item)}
                                    className={`flex flex-row items-center justify-evenly gap-x-1 border rounded-md px-2 md:px-4 py-2 md:py-3 text-sm font-medium transition
                                    ${
                                        isActive
                                        ? "border-black text-black"
                                        : "border-gray-300 text-gray-500 hover:border-gray-400"
                                    }
                                    `}
                                >
                                    <div>
                                    <a>{item.option} - </a>
                                    <small>({convertAmount(item.amount_plus)})</small>
                                    </div>
                                    <a className='text-[#dd4e09]'>{item.in_stock} left</a>
                                </button>
                                );
                            })}
                            </div>
                        </div>
                        );
                    })}
                    
                    <div className='my-2'>
                        <h3 className="font-semibold text-lg mb-4">Tip</h3>
                        <Collapsible title="Click to know your bra size">
                            <div className='flex flex-col text-start gap-y-2'>
                                <p className='text-sm'>Know your bra size</p>
                                <p onClick={() => window.open('/book-fitting', '_blank')} className='text-md font-medium text-[#7d5af6] text-underline'>Learn how to measure your bra size</p>
                            </div>
                        </Collapsible>
                    </div>

                    {/* Quantity */}
                    <div>
                        <h3 className="font-semibold text-lg mb-3">Qty</h3>
                        <div className='flex flex-row justify-between items-center'>
                            <div>
                                <div className="flex items-center border rounded-full w-40 overflow-hidden">
                                    <button
                                        className="w-12 h-12 text-xl"
                                        onClick={decreaseQty}
                                    >
                                        −
                                    </button>
                                    <div className="flex-1 text-center font-medium">{qty}</div>
                                    <button
                                        className="w-12 h-12 text-xl"
                                        onClick={increaseQty}
                                    >
                                        +
                                    </button>
                                </div>
                                {checkItemInCart(showDetails?.product_id) > 0 &&
                                    <a onClick={() => removeItem(showDetails?.product_id)} className="mt-3 underline cursor-pointer text-md text-[#7d5af6] flex items-center gap-x-1"><LiaTimesSolid color="#7d5af6" size={15} /> Remove {checkItemInCart(showDetails?.product_id)} from cart</a>
                                }
                            </div>
                            <div className='mt-5 px-5 self-start flex flex-col flex-start'>
                                <small>Final</small>
                                <strong className='text-lg md:text-2xl font-bold'>{convertAmount(pageData?.total_price)}</strong>
                            </div>
                        </div>
                    </div>
                        
                    {/* Actions */}
                    <div className="flex gap-4">
                        <button onClick={() => Object.keys(selected).length == pageData?.extras?.length ? addToCart(showDetails?.name, showDetails?.product_id, 'product', qty, selected, pageData?.total_price, pageData?.images[0].url) : setTostMessage({ messageType: 'error', message: 'Choose one option from all variations' })} className="flex-1 border-2 border-[#fc8c06] text-[#fc8c06] py-3 rounded-full font-semibold">
                        Add to Cart
                        </button>

                        {Object.keys(selected).length == pageData?.extras?.length ?
                        <button onClick={() => {addToCart(showDetails?.name, showDetails?.product_id, 'product', qty, selected, pageData?.total_price, pageData?.images[0].url); setShowModal(false); navigate('/my-cart') }} className="flex-1 bg-[#dd4039] text-white py-3 rounded-full">
                        <span className="font-bold">Checkout</span> Now
                        </button>
                        :
                        <button onClick={() => setTostMessage({ messageType: 'error', message: 'Choose one option from all variations' }) } className="flex-1 bg-[#dd4039] text-white py-3 rounded-full opacity-[0.5]">
                        <span className="font-bold">Checkout</span> Now
                        </button>
                        }
                    </div>
                </div>
                </>
                }
            </div>  
        </div>
    )
}

const Collapsible = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ border: "1px solid #ddd", borderRadius: 6 }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          padding: "12px",
          background: "#f5f5f5",
          border: "none",
          textAlign: "left",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        {title}
      </button>

      {open && (
        <div style={{ padding: "12px" }}>
          {children}
        </div>
      )}
    </div>
  );
};